module.exports = __webpack_public_path__ + "img/linkedin.465cf704.svg";